import { reduce } from "et3-type-guards";
import getReportsStore from "../../reports-store";
import getUserStore from "../../user-store";
import getUserAdvancedStore from "../../user-store/advanced-store";
import getTBWStore from ".";
import getInvestigationCasesStore from "../../investigation-cases-store";

export const banFromTBW = async () => {
  const reportId = reduce(() => getTBWStore().TBWExtraData.get().reportID, 0);
  const reportedId = reduce(
    () => getTBWStore().TBWExtraData.get().reportedID,
    0
  );
  const reportedUUID = reduce(
    () => getTBWStore().TBWExtraData.get().reportedUUID,
    ""
  );
  const userId = reduce(() => getTBWStore().TBWExtraData.get().userID, 0);
  const userUUID = reduce(() => getTBWStore().TBWExtraData.get().userUUID, "");
  const pageName = getTBWStore().TBWFromPage.get();
  switch (pageName) {
    case "REPORTS": {
      const extraData = getTBWStore().getTBWExtraData();
      return await getReportsStore().banReport(
        reportId,
        reportedId,
        reportedUUID,
        getTBWStore().TBWFromCase.get(),
        extraData,
        pageName
      );
    }
    case "USER_CONVERSATIONS":
    case "USER_ADVANCED":
    case "APPROVAL_DATA":
      const userStatus = getTBWStore().TBWFromCase.get();
      const oldStatus = reduce(
        () => getUserAdvancedStore().userData.get(userId).status,
        ""
      );
      return await getUserStore().changeUserStatus({
        userId,
        userUUID,
        selectedReasons: getTBWStore().getTWBValuesArray(),
        showTBW: false,
        userOldStatus: oldStatus,
        userStatus: userStatus,
        pageName
      });
    case "INVESTIGATION_CASES": {
      const investigationCaseID = reduce(
        () => getTBWStore().TBWExtraData.get().secondPartyID,
        -1
      );
      const TBWFromCase = getTBWStore().TBWFromCase.get();
      const evetnName =
        TBWFromCase === "banned"
          ? "ban"
          : TBWFromCase === "temporary_banned"
            ? "temporary_ban"
            : TBWFromCase === "silent_banned"
              ? "silent_ban"
              : "";
      const tbwExtraData = getTBWStore().getTBWExtraData();
      const status =
        await getInvestigationCasesStore().updateStatusAndInvestigationCase({
          investigationCaseID,
          eventName: evetnName,
          fromPage: "INVESTIGATION_CASES",
          userUUID,
          extraData: {
            pageName,
            TBW_ids: tbwExtraData.TBW_ids,
            temporaryBanDays: tbwExtraData.temporaryBanDays
          }
        });
      return status;
    }

    default:
      return "";
  }
};
